module.exports = __webpack_public_path__ + "static/media/lumbering28.cda3ad27.jpg";